export const isNotWideoPage = (props: string): boolean => {
  return (
    props === "/about/" ||
    props === "/contact/" ||
    props === "/incompatible/" ||
    props === "/404/" ||
    props === "/privacy-statement/"
  )
}
